// Shared client-side validation for the follow-up send window, used by the
// automation form and the pipeline rule form before submitting. Mirrors the
// server-side SendWindowConfigurable check (a non-empty day list and an end
// strictly after the start) so the user gets immediate feedback instead of a
// generic 422. A disabled/empty window is always valid (no restriction).
export const isSendWindowValid = window => {
  if (!window || window.enabled !== true) return true;

  const hasDays = Array.isArray(window.days) && window.days.length > 0;
  const hasTimes = Boolean(window.start) && Boolean(window.end);
  if (!hasDays || !hasTimes) return false;

  // "HH:MM" strings are zero-padded, so lexical comparison matches chronology.
  return window.end > window.start;
};
